<template>
  <v-row>
    <v-col>
      <v-text-field
        v-model="callToModel"
        ref="textfield"
        persistent-hint autofocus
        full-width :clearable="!calling"
        clear-icon="mdi-close-circle"
        :hint="hint"
        :placeholder="$t('sipua.box.dialfield')"
        :error-messages="errorMsgs"
        :disabled="calling"
        :loading="calling"
        @input="$emit('num-typing', $event)"
        @keyup.enter="$emit('init-call')"
        solo flat>
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'phone-app-dial-field',
  props: {
    callTo: {
      required: true
    },
    calling: {
      type: Boolean,
      required: true
    },
    hint: {
      type: String,
      required: true
    },
    errorMsgs: {
      type: Array,
      required: true
    }
  },
  computed: {
    callToModel: {
      get: function () {
        return this.callTo
      },
      set: function (val) {
        this.$emit('num-typing', val)
      }
    }
  },
  methods: {
    focus: function () {
      setTimeout(() => {
        const el = this.$refs?.textfield?.$el.querySelector('input')
        if (el) {
          el.setSelectionRange(el?.value.length, el?.value.length)
          el.focus()
        }
      }, 100)
    }
  }
}
</script>

<style>
</style>
